import React from 'react';
import PropTypes from 'prop-types';
import { Content, SideBar, Title, Wrapper } from './ReportStyles';
import ActiveAlerts from './ActiveAlerts/ActiveAlerts';
import ArchivedAlerts from './ArchivedAlerts/ArchivedAlerts';
import CreditScore from './CreditScore/CreditScore';
import Monitoring from './Monitoring/Monitoring';
import ActionItems from './ActionItems/ActionItems';
import Card from './Card/Card';

const Report = ({
  report: {
    ScoreDetail: { Score: score, ScoreRating: rating },
    ActiveAlerts: activeAlerts,
    ArchivedAlerts: archivedAlerts,
  },
}) => {
  return (
    <>
      <Title>Monitor</Title>
      <Wrapper>
        <Content>
          <ActiveAlerts alerts={activeAlerts} />
          <ArchivedAlerts alerts={archivedAlerts} />
        </Content>
        <SideBar>
          <Card title="VantageScore®">
            <CreditScore score={score} rating={rating} />
          </Card>
          <Card title="What We're Monitoring For You">
            <Monitoring />
          </Card>
          <Card title="What You Can Do...">
            <ActionItems />
          </Card>
        </SideBar>
      </Wrapper>
    </>
  );
};

Report.propTypes = {
  report: PropTypes.shape({
    ScoreDetail: PropTypes.shape({
      Score: PropTypes.number,
      ScoreRating: PropTypes.string,
    }),
    ActiveAlerts: PropTypes.arrayOf(PropTypes.shape({})),
    ArchivedAlerts: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
};

export default Report;
